import { Button } from '@mui/material'
import styles from './FilterSelectorButton.module.css'
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown'
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp'
import classNames from 'classnames'

interface FilterSelectorButtonProps {
    value?: string
    caption?: string
    onClick?: (event: any) => void
    ref: any
    className?: string
    open?: boolean
}

export const FilterSelectorButton = (props: FilterSelectorButtonProps): JSX.Element => {
    const {
        className,
        caption,
        value,
        onClick,
        ref,
        open
    } = props

    const endIcon = <KeyboardArrowDownIcon />
    const handleButtonClick = (event: any) => {
        onClick?.(event)
    }
    const filterButtonClasses = classNames(styles.FilterSelectorButton, className)

    const renderIcon = () => {
        if (open) {
            return (
                <KeyboardArrowUpIcon
                    className={styles.FilterSelectorButton__Icon}
                />
            )
        }

        return (
            <KeyboardArrowDownIcon
                className={styles.FilterSelectorButton__Icon}
            />
        )

    }


    return (
        <button
            className={filterButtonClasses}
            onClick={handleButtonClick}
            ref={ref}
        >  
            <span className={styles.FilterSelectorButton__Value}>{value || caption}</span>
            {
                renderIcon()
            }
        </button>

        //<Button
        //    variant="contained"
        //    className={filterButtonClasses}
        //    endIcon={endIcon}
        //    onClick={handleButtonClick}
        //    ref={ref}
        //>
        //    <span className={styles.FilterSelectorButton__Value}>{value}</span>
        //</Button>
    )
}